import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SVGFill } from '../../svg';
import { Icon } from '../../icon';
var ChooseNumberOfColumnsIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref
  }, props), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.09524 42.7454C4.09524 43.3821 4.61795 43.9048 5.2546 43.9048H42.7454C43.382 43.9048 43.9047 43.3821 43.9047 42.7454V5.25462C43.9047 4.61796 43.382 4.09525 42.7454 4.09525H5.2546C4.61795 4.09525 4.09524 4.61796 4.09524 5.25462L4.09524 42.7454ZM5.2546 46C3.46078 46 2 44.5392 2 42.7454L2 5.25462C2 3.4608 3.46078 2.00001 5.2546 2.00001H42.7454C44.5392 2.00001 46 3.46079 46 5.25462V42.7454C46 44.5392 44.5392 46 42.7454 46H5.2546Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.00001 13.5238C2.00001 12.9452 2.46904 12.4762 3.04763 12.4762L44.9524 12.4762C45.531 12.4762 46 12.9452 46 13.5238L46 24C46 24.5786 45.531 25.0476 44.9524 25.0476L3.04763 25.0476C2.46905 25.0476 2.00001 24.5786 2.00001 24L2.00001 13.5238ZM4.09525 14.5714L4.09525 22.9524L43.9048 22.9524L43.9048 14.5714L4.09525 14.5714Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.00001 24C2.00001 23.4214 2.46904 22.9524 3.04763 22.9524L44.9524 22.9524C45.531 22.9524 46 23.4214 46 24V34.4762C46 35.0548 45.531 35.5238 44.9524 35.5238L3.04763 35.5238C2.46905 35.5238 2.00001 35.0548 2.00001 34.4762L2.00001 24ZM4.09525 25.0476L4.09525 33.4286L43.9048 33.4286L43.9048 25.0476L4.09525 25.0476Z"
  }));
});
ChooseNumberOfColumnsIcon.displayName = 'ChooseNumberOfColumnsIcon';
ChooseNumberOfColumnsIcon.defaultProps = {
  'aria-label': 'ChooseNumberOfColumns'
};
export default ChooseNumberOfColumnsIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/theme/dist/esm/icons/ChooseNumberOfColumnsIcon/index.js
// module id = 1805
// module chunks = 12